import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { EncryptionService } from '@app/shared/services/Encryption.service';
import { LoginService } from '@app/shared/services/Login.service';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.less'],
})
export class ResetPassComponent extends BaseComponent implements OnInit {
  passwordVisible = false;
  Password = '';
  mode = 'request';
  email = '';
  token: any;
  result = {
    show: false,
    title: '',
    subTitle: '',
  };

  constructor(
    injector: Injector,
    private encryptionService: EncryptionService,
    private authService: LoginService
  ) {
    super(injector);
  }

  ngOnInit() {
    const qParams = this.route.snapshot.queryParams;
    let encodedEmail = qParams['email'] as string;
    const token = qParams['recoveryToken'];
    if (encodedEmail == null || token == null) {
      this.mode = 'request';
    } else {
      this.mode = 'reset';
      if (encodedEmail.includes(' ')) {
        encodedEmail = encodedEmail.replace(/ /g, '+');
      }
      this.email = this.encryptionService.decryptUsingTripleDES(encodedEmail);
      this.token = token;
    }
  }

  sendResetRequest() {
    this.authService.sendResetPassRequest(this.email).subscribe(() => {
      this.result = {
        show: true,
        title: 'Reset request sent',
        subTitle:
          'Please follow the link that will be included in the reset email',
      };
    });
  }
  resetPassowrd() {
    this.authService
      .resetPassword(this.token, this.email, this.Password)
      .subscribe(() => {
        this.result = {
          show: true,
          title: 'Password has been reset ',
          subTitle:
            'Your password has been reset successfully, please go to login page to use the new password',
        };
      });
  }
}
